export const appContextConstants = {
  SET_APP_CONTEXT: 'SET_APP_CONTEXT',
  SET_LOAN_CONTEXT: 'SET_LOAN_CONTEXT',
  SET_REGEN_CONTEXT: 'SET_REGEN_CONTEXT',
  SET_ACTIVITY_CONTEXT: 'SET_ACTIVITY_CONTEXT',
  SET_REPAYMENTS_CONTEXT: 'SET_REPAYMENTS_CONTEXT',
  SET_REFETCH_CONTEXT: 'SET_REFETCH_CONTEXT',
  SET_FOIR_DATA: 'SET_FOIR_DATA',
  CLEAR_APP_CONTEXT: 'CLEAR_APP_CONTEXT',
};
